// extracted by mini-css-extract-plugin
export default {"sensors":"MonitoringData_sensors__L4T9M","sensor":"MonitoringData_sensor__VZ501","minmaxTemperatureWrapper":"MonitoringData_minmaxTemperatureWrapper__ionMG"};